import {CaregiverMode} from '../../../../../enums/caregiver-mode';
import {useParams} from 'react-router-dom';
import {ActivityTimeline} from '../../../../../components/activity-timeline/activity-timeline';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../i18n/translations';

export default function ActivityInformalCaregiverOfficeScreen() {
  let {seniorId}: {seniorId?: string} = useParams();
  const {t} = useTranslation();

  return (
    <ActivityTimeline
      headerTitle={t(translations.office.system_administrator.tabs.activity)}
      caregiverMode={CaregiverMode.Informal}
      participantUserId={seniorId}
    />
  );
}
